import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { portalApi } from "./portalApi";

const PortalAuthContext = createContext(null);

export const PortalAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await portalApi.get("/me");
      setCustomer(res.data);
    } catch (e) {
      setCustomer(null);
      localStorage.removeItem("portal_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("portal_token")) refresh();
    else setLoading(false);
  }, [refresh]);

  const login = async (no_layanan, password) => {
    const res = await portalApi.post("/login", { no_layanan, password });
    localStorage.setItem("portal_token", res.data.token);
    await refresh();
    return res.data.customer;
  };

  const logout = () => {
    localStorage.removeItem("portal_token");
    setCustomer(null);
  };

  return (
    <PortalAuthContext.Provider value={{ customer, loading, login, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  );
};

export const usePortalAuth = () => useContext(PortalAuthContext);
